import {
  Button,
  FieldWrapper,
  FlexBox,
  ModalBody,
  ModalHead,
} from '@dixa/lib-shared-habla';
import {
  findNodePath,
  setNodes,
} from 'lib-knowledge-document-structure/plate/common';
import {
  MyEditor,
  MyHtmlElement,
} from 'lib-knowledge-document-structure/plateTypes';
import { EditorWithLoading } from 'lib-knowledge-form';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';
import { useState } from 'react';

import styles from './htmlBlockEditModal.module.scss';

type HtmlBlockEditModalContentProps = {
  editor: MyEditor;
  element: MyHtmlElement;
};

export function HtmlBlockEditModal({
  element,
  editor,
}: HtmlBlockEditModalContentProps): JSX.Element {
  const [html, setHtml] = useState(element.html || '');
  const { hideModal } = useModal();
  const onSave = () => {
    const path = findNodePath(editor, element);
    setNodes(editor, { html }, { at: path });
    hideModal();
  };

  const isFormValid = html.length > 0;

  return (
    <ModalWrapper>
      <ModalHead title="Edit Custom HTML" onClose={hideModal}></ModalHead>
      <ModalBody>
        <FieldWrapper>
          <EditorWithLoading
            className={styles.editor}
            height={240}
            theme="vs-dark"
            defaultLanguage="html"
            options={{
              minimap: { enabled: false },
              folding: false,
              lineHeight: 20,
              formatOnPaste: true,
              formatOnType: true,
              padding: {
                top: 16,
              },
            }}
            onMount={(ed) =>
              ed.getAction('editor.action.formatDocument')?.run()
            }
            value={html}
            onChange={(e) => e && setHtml(e)}
          />
        </FieldWrapper>

        <FlexBox justifyContent="flex-end" gap="100">
          <Button variant="tertiary" onClick={hideModal}>
            Cancel
          </Button>

          <Button disabled={!isFormValid} onClick={onSave}>
            Save
          </Button>
        </FlexBox>
      </ModalBody>
    </ModalWrapper>
  );
}
